import React, { useState, useEffect } from "react";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { timesheetApi, Util } from "../../services";
import { DataTable } from "primereact/datatable";
import { Card } from "primereact/card";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { confirmDialog } from "primereact/confirmdialog";

const CreateTimesheet = ({ userData }) => {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(Util.getMondayOfCurrentWeek());
  const [allocatedProjectData, setAllocatedProjectData] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [draftProject, setDraftProject] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [selectedJiraTaskId, setSelectedJiraTaskId] = useState("");
  const [selectedHour, setSelectedHour] = useState("");
  const [mapCategory, setMapCategory] = useState({});
  const [totalDraftHours, setTotalDraftHours] = useState(0);
  const [errorLog, SetErrorLog] = useState(false);
  const [totalHrError, setTotalHrError] = useState(false);
  const [totalHrWarning, setTotalHrWarning] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  var currentUser = JSON.parse(localStorage.getItem("user"));
  const [count1, setCount1] = React.useState(1000);

  let count = 0;
  useEffect(() => {
    formik.setFieldValue("timesheetDays", 1);
    if (count == 0) {
      setTotalHrWarning(false);
      setTotalHrError(false);
      setTotalDraftHours(0);
      fetchAllocatedProjectByUserManager();
      count++;
    }
  }, [userData]);

  /* Employee/Manager Allocated Project List Start */
  const fetchAllocatedProjectByUserManager = () => {
    timesheetApi.getAllocatedProjectByUserManager(userData.id).then((resp) => {
      try {
        const activeProjects = resp.data.data.filter((x) => {
          return x.status === 1;
        });
        setDraftProject(activeProjects);
        setAllocatedProjectData(activeProjects);
      } catch (error) {
        // Error handle
      }
    });
  };
  /* Employee/Manager Allocated Project List End */

  const validateError = () => {
    if (
      selectedCategory === "" ||
      selectedActivity === "" ||
      // selectedProperty === "" ||
      selectedHour === ""
    ) {
      SetErrorLog(true);
      return true;
    }
  };

  const accept = (data) => {
    if (userData?.LegalEntity?.code === "ESAU") {
      if (totalDraftHours !== 8) {
        toast.error("Total hours must be exactly 8 for Australia region.");
        return;
      }
      const hasFullDaySickLeave = draftProject.some((p) =>
        p.projects?.some(
          (item) =>
            item.categoryName === "Leave/PH" &&
            item.activityName === "Sick Leave" &&
            parseFloat(item.hours) === 8,
        ),
      );
      // if (hasFullDaySickLeave) {
      //   toast.error(
      //     "Full day Sick Leave cannot be applied from timesheet. Please apply directly from the Leave Module.",
      //   );
      //   return;
      // }
    }

    if (totalDraftHours > 24) {
      toast.error("Total hours cannot be more than 24.");
      return;
    }
    var projectListing = [];
    for (let i = 0; i < draftProject.length; i++) {
      if (draftProject[i]["projects"]) {
        draftProject[i]["projects"].map((item) => {
          let objProject = {
            projectId: item.projectId,
            activityId: item.activityId,
            categoryId: item.categoryId,
            hours: parseFloat(item.hours),
            jiraTaskId: item.jiraTaskId,
            isBillable: item.isBillable,
            description: item.description,
          };
          projectListing.push(objProject);
        });
      }
    }

    let param = {
      userId: userData.id,
      date: Util.dateConverter(data.timesheetDate),
      comments: data.timesheetDescription,
      totalDays: data.timesheetDays,
      allocatedProjects: projectListing,
    };
    try {
      timesheetApi.createTimesheetByUserManager(param).then(
        (resp) => {
          toast.info("Timesheet created successfully...");
          navigate("/timesheets");
        },
        (resp) => {
          toast.error(resp?.response?.data?.message || resp?.response?.data?.error || "Unable to create timesheet...");
        },
      );
    } catch (error) {
      toast.error(error?.response?.data?.message || "Unable to create timesheet...");
    }
    // }
  };

  const confirmSubmitPopUp = (data) => {
    confirmDialog({
      message: "Are you sure to create Timesheet for " + userData.name + "?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      // accept:accept(data),
      accept: () => accept(data),
      reject,
    });
  };

  const formik = useFormik({
    initialValues: {
      timesheetDate: startDate,
      timesheetDescription: "",
      timesheetDays: "",
      totalDraftExceedHours: "",
    },

    validate: (data) => {
      let errors = {};

      if (userData?.location === "ESAU" && totalDraftHours > 8) {
        errors.totalDraftExceedHours =
          "Total hours cannot be more than 8 for Australia region.";
        toast.error(errors.totalDraftExceedHours);
      } else if (totalDraftHours > 24) {
        errors.totalDraftExceedHours = "Total hours cannot be more than 24.";
        toast.error(errors.totalDraftExceedHours);
      }

      if (!data.timesheetDays) {
        errors.timesheetDays = "Days is required.";
      }
      return errors;
    },

    onSubmit: (data) => {
      confirmSubmitPopUp(data);
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const onCategoryChange = (e) => {
    setSelectedCategory(e.value);
  };
  const onActivityChange = (e) => {
    setSelectedActivity(e.value);
  };
  const onHourChange = (e) => {
    setSelectedHour(e.target.value);
  };
  const onDescriptionChange = (e) => {
    setSelectedDescription(e.target.value);
  };
  const onJiraTaskIdChange = (e) => {
    setSelectedJiraTaskId(e.target.value);
  };

  const changeDate = (e) => {
    formik.setFieldValue("timesheetDate", e.value);
    setStartDate(e.value);
    var dateObj = {
      date: moment(e.value).format("DD-MM-YYYY"),
      userId: userData.id,
    };
    try {
      timesheetApi.existingTimesheetCheck(dateObj).then(
        (resp) => {
          if (resp.data.error) toast.error(resp.data.error);
        },
        (err) => {
          toast.error(err);
        },
      );
    } catch (error) {
      toast.error("Unable to create timesheet");
    }
  };

  /* FOR CONFIRMATION DIAGOG BOX */
  const [isConfirmDialogVisiable, setIsConfirmDialogVisiable] = useState(false);

  const reject = () => {
    setIsConfirmDialogVisiable(true);
  };
  /* FOR CONFIRMATION DIALOG BOX */

  const confirmDeleteTimesheet = (data, i) => {
    confirmDialog({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      acceptLabel: "No",
      rejectLabel: "Yes",
      accept: () => {},
      reject: () => acceptFunc(data, i),
    });
  };

  const acceptFunc = (data, i) => {
    let arr = draftProject[i].projects.filter((obj) => {
      return (
        obj.activityId !== data.activityId ||
        obj.categoryId !== data.categoryId ||
        obj.hours != data.hours
      );
    });
    const draftData = [...draftProject];
    if (draftData[i].hasOwnProperty("projects")) {
      draftData[i].projects = arr;
      draftData[i].totHrs = draftData[i]?.projects.reduce(
        (acc, curr) => acc + parseFloat(curr.hours),
        0,
      );
    }
    let total = 0;
    for (let i = 0; i < draftData.length; i++) {
      total += draftData[i].totHrs ? draftData[i].totHrs : 0;
    }
    if (total > 24) {
      setTotalHrError(true);
      setTotalHrWarning(true);
    } else if (total > 8) {
      setTotalHrWarning(true);
      setTotalHrError(false);
    } else {
      setTotalHrWarning(false);
      setTotalHrError(false);
    }
    setTotalDraftHours(total);
    setDraftProject(draftData);
  };

  const saveDraftTimesheet = (index, e) => {
    const error = validateError();
    if (error) {
    } else {
      let activityIsBillable = e.Project.activities.find((item) => {
        return item.id === selectedActivity.id && e.projectId;
      });
      const draftData = [...draftProject];
      const clickedProjectData = {
        projectId: e.projectId,
        categoryId: selectedCategory.id,
        categoryName: selectedCategory.title,
        activityId: selectedActivity.id,
        activityName: selectedActivity.title,
        isBillable: activityIsBillable.isBillable,
        hours: selectedHour,
        jiraTaskId: selectedJiraTaskId,
        description: selectedDescription,
      };

      if (draftData[index].hasOwnProperty("projects")) {
        const isDuplicate = draftData[index].projects.filter((x) => {
          return (
            x.activityId === clickedProjectData.activityId &&
            x.categoryId === clickedProjectData.categoryId
          );
        });

        if (isDuplicate.length > 0) {
          toast.error("You cannot add duplicate timesheet activity!");
        } else {
          draftData[index]?.projects.push(clickedProjectData);
          draftData[index].totHrs = draftData[index]?.projects.reduce(
            (acc, curr) => acc + parseFloat(curr.hours),
            0,
          );
        }
      } else {
        draftData[index].projects = [clickedProjectData];
        draftData[index].totHrs = draftData[index]?.projects.reduce(
          (acc, curr) => acc + parseFloat(curr.hours),
          0,
        );
      }
      let total = 0;
      for (let i = 0; i < draftData.length; i++) {
        total += draftData[i].totHrs ? draftData[i].totHrs : 0;
      }
      if (total > 24) {
        setTotalHrWarning(true);
        setTotalHrError(true);
      } else if (total > 8) {
        setTotalHrWarning(true);
        setTotalHrError(false);
      } else {
        setTotalHrWarning(false);
        setTotalHrError(false);
      }
      setTotalDraftHours(total);
      setDraftProject(draftData);

      setDisabled(false);
      setSelectedCategory(null);
      setSelectedActivity(null);
      setSelectedHour("");
      setSelectedDescription("");
      setSelectedJiraTaskId("");
      SetErrorLog(false);
    }
  };

  const onRowEditComplete = (e, i) => {
    let actIsBillable;
    const _draftProject = [...draftProject[i].projects];
    let { newData, index } = e;
    let actId = newData.activityName.id;
    let actTitle = newData.activityName.title;

    let catId = newData.categoryName.id;
    let catTitle = newData.categoryName.title;

    if (newData.activityName.id === undefined) {
      actIsBillable = e.data.isBillable;
    } else {
      actIsBillable = newData.activityName.isBillable;
    }
    newData["activityId"] = actId ? actId : e.data.activityId;
    newData["activityName"] = actTitle ? actTitle : e.data.activityName;
    newData["isBillable"] = actIsBillable;

    newData["categoryId"] = catId ? catId : e.data.categoryId;
    newData["categoryName"] = catTitle ? catTitle : e.data.categoryName;

    _draftProject[index] = newData;
    const updateDraftData = [...draftProject];
    updateDraftData[i].projects = _draftProject;
    updateDraftData[i].totHrs = updateDraftData[i].projects.reduce(
      (acc, curr) => acc + parseFloat(curr.hours),
      0,
    );

    let total = 0;
    for (let i = 0; i < updateDraftData.length; i++) {
      total += updateDraftData[i].totHrs ? updateDraftData[i].totHrs : 0;
    }
    if (total > 24) {
      setTotalHrWarning(true);
      setTotalHrError(true);
    } else if (total > 8) {
      setTotalHrWarning(true);
      setTotalHrError(false);
    } else {
      setTotalHrWarning(false);
      setTotalHrError(false);
    }
    setTotalDraftHours(total);
    setDraftProject(updateDraftData);
  };

  const textEditor = (options) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        onKeyPress={Util.preventCharWithMinus}
        maxfractiondigits={2}
        maxLength={5}
        onPaste={Util.preventPasteChar}
      />
    );
  };

  const textDescription = (options) => {
    return (
      <InputTextarea
        style={{ width: "150px" }}
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        rows={1}
        cols={30}
      />
    );
  };
  const textJiraTaskId = (options) => {
    return (
      <InputTextarea
        style={{ width: "150px" }}
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        rows={1}
        cols={30}
      />
    );
  };

  const categoryEditor = (options, i) => {
    setMapCategory(options.value);
    let categoryList;
    categoryList = draftProject.map((el) => {
      var userCatList = el.Project.categories.filter((obj) => {
        return (
          (obj.userId === currentUser.id || obj.userId === null) &&
          obj.status === 1
        );
      });
      return userCatList;
    });
    return (
      <Dropdown
        value={options.value}
        options={categoryList[i]}
        optionLabel="title"
        optionValue="title"
        onChange={(e) => options.editorCallback(e.value)}
        placeholder="Select Category"
        itemTemplate={(option) => {
          return <span>{option.title}</span>;
        }}
      />
    );
  };

  const activityEditor = (options, i) => {
    let activityList;
    activityList = draftProject.map((el) => {
      var userActList = el.Project.activities.filter((obj) => {
        // return obj.status === 1;
        if (mapCategory) {
          if (mapCategory == "Leave/PH") {
            return (
              (obj.userId === currentUser.id || obj.userId === null) &&
              obj.status === 1 &&
              obj.type === "0"
            );
          } else {
            return (
              (obj.userId === currentUser.id || obj.userId === null) &&
              obj.status === 1 &&
              obj.type === "1"
            );
          }
        } else {
          return (
            (obj.userId === currentUser.id || obj.userId === null) &&
            obj.status === 1
          );
        }
      });
      return userActList;
    });
    return (
      <Dropdown
        value={options.value}
        options={activityList[i]}
        optionLabel="title"
        optionValue="title"
        onChange={(e) => options.editorCallback(e.value)}
        placeholder="Select Activity"
        itemTemplate={Util.activityItemBody}
      />
    );
  };

  /* Delete draft timesheet by id start */

  const timesheetDeleteBodyTemplate = (rowData, i) => {
    return (
      <React.Fragment>
        <Button
          type="button"
          icon="pi pi-trash"
          className="p-button-rounded p-button-danger mr-1"
          onClick={() => confirmDeleteTimesheet(rowData, i)}
        />
      </React.Fragment>
    );
  };
  /* Delete draft timesheet by id end */
  const ChargeableOrNot = (el) => {
    return el?.isBillable ? (
      <span style={{ color: "green" }}>Chargeable</span>
    ) : (
      <span style={{ color: "red" }}>Non Chargeable</span>
    );
  };

  const projectList = draftProject.map((el, i) => {
    var userCatList = el.Project.categories.filter((obj) => {
      return (
        (obj.userId === currentUser.id || obj.userId === null) &&
        obj.status === 1
      );
    });

    var userActList = el.Project.activities.filter((obj) => {
      if (selectedCategory) {
        if (selectedCategory?.code === "LH") {
          return obj.status === 1 && (obj.type === "0" || obj.type === null);
        } else {
          return obj.status === 1 && obj.type === "1";
        }
      } else {
        return obj.status === 1;
      }
    });

    return (
      <AccordionTab
        key={"AccordionTab" + el}
        header={
          <React.Fragment>
            <div className="grid custom_width">
              <div className="col-10">
                <span>{el.Project.title}</span>
                {el?.isBillable === true ? (
                  <span
                    style={{
                      marginLeft: "20px",
                      height: "18px",
                      color: "green",
                    }}
                  >
                    Billable
                  </span>
                ) : (
                  <span
                    style={{ marginLeft: "20px", height: "18px", color: "red" }}
                  >
                    Non-Billable
                  </span>
                )}
              </div>
              <div className="col-2">
                <span>Hours: {el.totHrs ? el.totHrs?.toFixed(2) : 0}</span>
              </div>
            </div>
          </React.Fragment>
        }
      >
        <div className="formgrid grid">
          <InputText
            id="timesheetProject"
            name="timesheetProject"
            type="hidden"
            value={el.Project.id}
            maxLength={16}
            disabled
            placeholder="Project"
            className="mt-2"
          />
          <div
            className="field col-2"
            style={{ width: "155px", paddingRight: "3px" }}
          >
            <label>
              <i className="custom-tooltip-btn pi pi-info-circle"></i> Category
            </label>
            <label style={{ color: "red", marginLeft: "3px" }}>*</label>
            <Tooltip target=".custom-tooltip-btn">
              {el.Project.categories.map((item, i) => {
                return (
                  <p key={"ss" + i}>
                    {item.code}: {item.title}
                  </p>
                );
              })}
            </Tooltip>
            <Dropdown
              showClear
              id="timesheetCategory"
              name="timesheetCategory"
              options={userCatList}
              optionLabel="title"
              placeholder="Select Category"
              value={selectedCategory}
              onChange={onCategoryChange}
              className={classNames(
                { "p-invalid": errorLog && !selectedCategory },
                "mt-2",
              )}
              appendTo="self"
            />
            {errorLog && (
              <span>
                {selectedCategory === null && (
                  <div style={{ color: "red" }}>Select Category!</div>
                )}
              </span>
            )}
          </div>

          <div
            className="field col-2"
            style={{ width: "155px", paddingRight: "3px" }}
          >
            <label className="ml-1">Activity</label>
            <label style={{ color: "red", marginLeft: "3px" }}>*</label>
            <Dropdown
              showClear
              id="timesheetActivity"
              name="timesheetActivity"
              itemTemplate={Util.activityItemBody}
              options={userActList}
              optionLabel="title"
              placeholder="Select Activity"
              value={selectedActivity}
              onChange={onActivityChange}
              className={classNames(
                { "p-invalid": errorLog && !selectedActivity },
                "mt-2",
              )}
              appendTo="self"
            />
            {errorLog && (
              <span>
                {selectedActivity === null && (
                  <div style={{ color: "red" }}>Select Activity!</div>
                )}
              </span>
            )}
          </div>
          <div
            className="field col-2"
            style={{ width: "155px", paddingRight: "7px", paddingLeft: "7px" }}
          >
            <label>Hours</label>
            <label style={{ color: "red", marginLeft: "3px" }}>*</label>
            <InputText
              onKeyPress={Util.preventMinus}
              onPaste={Util.preventPasteChar}
              maxLength={5}
              maxfractiondigits={2}
              id="timesheetHours"
              name="timesheetHours"
              type="text"
              value={selectedHour}
              onChange={onHourChange}
              placeholder="Hours"
              className={classNames(
                { "p-invalid": errorLog && !selectedHour },
                "mt-2",
              )}
            />
            {errorLog && (
              <span>
                {selectedHour === "" && (
                  <div style={{ color: "red" }}>Enter Hours!</div>
                )}
              </span>
            )}
          </div>
          <div
            className="field col-2"
            style={{ width: "155px", paddingRight: "7px", paddingLeft: "3px" }}
          >
            <label>JIRA / Task ID</label>
            <InputTextarea
              id="timesheetJiraTaskId"
              name="timesheetJiraTaskId"
              value={selectedJiraTaskId}
              onChange={onJiraTaskIdChange}
              placeholder="JIRA / Task ID"
              className={classNames("mt-2")}
              rows={1}
              cols={30}
            />
          </div>

          <div
            className="field col-2"
            style={{ width: "155px", paddingRight: "7px", paddingLeft: "3px" }}
          >
            <label htmlFor="description">Description</label>
            <InputTextarea
              id="description"
              name="description"
              value={selectedDescription}
              onChange={onDescriptionChange}
              rows={1}
              cols={40}
              placeholder="Description"
              className={classNames("mt-2")}
            />
          </div>

          <div
            className="field col-1 ml-2"
            style={{ width: "96px", paddingRight: "7px", paddingTop: "24px" }}
          >
            <Button
              type="button"
              label="Add"
              icon="pi pi-check"
              className="p-button-rounded mt-2"
              onClick={(e) => saveDraftTimesheet(i, el)}
              
            />
          </div>
        </div>
        <Card>
          <DataTable
            value={el.projects ? el.projects : []}
            editMode="row"
            dataKey="id"
            onRowEditComplete={(e) => onRowEditComplete(e, i)}
          >
            <Column
              field="categoryName"
              header="Category"
              editor={(options) => categoryEditor(options, i)}
            ></Column>
            <Column
              field="activityName"
              header="Activity"
              editor={(options) => activityEditor(options, i)}
            ></Column>
            <Column header="Billing Type" body={ChargeableOrNot}></Column>
            <Column
              field="hours"
              header="Hours"
              editor={(options) => textEditor(options)}
            ></Column>
            <Column
              field="jiraTaskId"
              header="JIRA / Task ID"
              editor={(options) => textJiraTaskId(options)}
            ></Column>
            <Column
              field="description"
              header="Description"
              editor={(options) => textDescription(options)}
            ></Column>
            <Column
              rowEditor
              style={{ minWidth: "8rem" }}
              bodyStyle={{
                textAlign: "end",
                paddingRight: "6px",
                borderColor: "none",
              }}
            ></Column>
            <Column
              field=""
              header=""
              style={{ paddingLeft: "0px" }}
              body={(e) => timesheetDeleteBodyTemplate(e, i)}
            ></Column>
          </DataTable>
        </Card>
      </AccordionTab>
    );
  });

  return (
    <form
      onSubmit={formik.handleSubmit}
      className="p-fluid p-grid"
      autoComplete="off"
    >
      {getFormErrorMessage("totalDraftExceedHours")}

      {totalHrWarning && (
        <div className="formgrid grid">
          <div className="field col-12 danger">
            <label htmlFor="timesheet24hrs">
              Warning: Recorded hours differ from defined working hours for the
              day
            </label>
          </div>
        </div>
      )}
      <div className="accordion-demo">
        <div className="card">
          <div className="formgrid grid" style={{justifyContent: 'space-between', alignItems: 'center'}}>
            <div>
              <label htmlFor="timesheetDate" className="mt-2 ml-2">Date : </label>
              <div className="field mt-2 ml-2">
                <Calendar id="icon" value={startDate} onChange={(e) => changeDate(e)} placeholder="Date" showIcon dateFormat="dd-mm-yy" />
              </div>
            </div>
            <div className="field mt-2">
              Total Hours: <strong>{totalDraftHours ? totalDraftHours?.toFixed(2) : 0}</strong>
            </div>
          </div>
          <Accordion activeIndex={0}>{projectList}</Accordion>
        </div>
        <div className="formgrid grid mobile_grid">
          <div className="field col-4 mt-4">
            <label htmlFor="timesheeDescription">Comments(Optional) : </label>
            <InputTextarea
              id="timesheetDescription"
              name="timesheetDescription"
              value={formik.values.timesheetDescription}
              onChange={(e) => {
                formik.handleChange(e);
                setCount1(e.target.value.length);
              }}
              rows={3}
              cols={40}
              maxLength={1000}
            />
            <span style={{ float: "right" }}>
              {count1 === 1000 ? 1000 : 1000 - count1} Character(s) Left
            </span>
          </div>
          <div className="field col-5 mt-4">
            <div className="formgrid grid">
              <div className="field mt-2 mr-2">
                Add with same data for next
              </div>
              <div className="field">
                <span className="p-float-label">
                  <InputText
                    onKeyPress={Util.preventMinus}
                    onPaste={Util.preventPasteChar}
                    id="timesheetDays"
                    name="timesheetDays"
                    type="text"
                    value={formik.values.timesheetDays}
                    onChange={formik.handleChange}
                    style={{ width: "50px" }}
                    maxLength={1}
                  />
                  {getFormErrorMessage("timesheetDays")}
                </span>
              </div>
              <div className="field mt-2 ml-2">{formik.values.timesheetDays > 1 ? "days" : "day"}</div>
            </div>
          </div>
          <div className="field col-3 mt-4">
            <Button
              disabled={disabled}
              type="submit"
              label="Save & Review"
              icon="pi pi-check"
              className="p-button-rounded"
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default CreateTimesheet;